import { ProcessoVisualizadorComponent } from './../processo-visualizador/processo-visualizador.component';
import { MensagemService } from 'maestro-ng';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Processo } from '../processo.model';
import { ProcessoService } from '../processo.service';

@Component({
  selector: 'app-processo-historico',
  templateUrl: './processo-historico.component.html',
  styleUrls: ['./processo-historico.component.css'],
})
export class ProcessoHistoricoComponent implements OnInit {
  public processo: Processo;
  public tabViewIndex = ProcessoVisualizadorComponent.TAB_DOCUMENTOS;
  public tabViewDocumentosIndex = ProcessoVisualizadorComponent.TAB_DOCUMENTOS_DADOS;

  constructor(
    private service: ProcessoService,
    private mensagemService: MensagemService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.params
      .subscribe((params) => {
        if (params['tabView']) {
          this.tabViewIndex = +params['tabView'];
        }

        if (params['tabViewDocumentos']) {
          this.tabViewDocumentosIndex = +params['tabViewDocumentos'];
        }

        if (params['id']) {
          const id = params['id'].includes('?') ? params['id'].split('?')[0] : params['id'].split('%')[0];
          this.service
            .recuperarPorId(id)
            .then((processo) => this.carregarDadosProcesso(processo))
            .catch((e) => {
              if (e.status === 403) {
                const titulo = 'Acesso não autorizado';
                const texto = 'O acesso ao Processo : ' + params['id'] + ' não permitido';
                const recurso = e.url;
                this.router.navigate(['/aviso', { titulo: titulo, texto: texto, recurso: recurso }]);
              }
              this.mensagemService.addErro('Erro ao carregar', 'Erro ao recuperar o Processo!');
            });
        } else if (params['fonteDados'] && params['origemId']) {
          this.service
            .recuperarPorOrigemId(params['fonteDados'], params['origemId'])
            .then((processo) => this.carregarDadosProcesso(processo))
            .catch((e) => {
              if (e.status === 403) {
                const titulo = 'Acesso não autorizado';
                const texto =
                  'O acesso com as informações : ' + params['fonteDados'] + ' e ' + params['origemId'] + ' não permitido';
                const recurso = e.url;
                this.router.navigate(['/aviso', { titulo: titulo, texto: texto, recurso: recurso }]);
              }
              this.mensagemService.addErro('Erro ao carregar', 'Erro ao recuperar o Processo!');
            });
        }
      })
      .unsubscribe();
  }

  public carregarDadosProcesso(processo: Processo): void {
    this.processo = processo;
  }
}
